import { makeVar } from '@apollo/client'

/** The Connect wallet dialog of a signed-in user (header and game buttons). */
export const isConnectWalletOpenVar = makeVar(false)
